// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"styles_tableRow__27bYx","parameters":"styles_parameters__2r9so","comments":"styles_comments__1ffDe"};